import "../css/PopupSectionTitle.css";

export default ({ title }) => {
  return (
    <div className="popup-row popup-row-title">
      <span>{title}</span>
    </div>
  );
};
